import { AfterViewInit, Component, EventEmitter, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Sort } from '@angular/material/sort';
import { BaseComponent } from 'src/app/core/base.component';
import { OutingService } from 'src/app/outing/outing.service';
import { AlertModalComponent } from 'src/app/shared/modals/alert-modal/alert-modal.component';
import { GlobalDataService } from 'src/app/shared/services/global-data.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { OutingPermissionTypes } from '../models/outing-permission-types';
import { OutingPermissionUsersQueryFilter } from '../models/outing-permission-users-query-filter';
import { OutingPermissionUsersList } from '../models/outing-permission-users.list';
import { OutingPermssionDto } from '../dtos/outing-permission.dto';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';

@Component({
    selector: 'app-outing-permission-create',
    templateUrl: './outing-permission-create.component.html',
    styleUrls: ['./outing-permission-create.component.scss'],
    standalone: false
})
export class OutingPermissionCreateComponent extends BaseComponent implements OnInit, AfterViewInit {
  @Input() filter: OutingPermissionUsersQueryFilter = new OutingPermissionUsersQueryFilter();
  public updateFilterEvent = new EventEmitter<any>();
  public outingPermissionUsers: OutingPermissionUsersList[] = [];
  public outingPermissionTypes: OutingPermissionTypes[] = [];


  constructor(public sessionService: SessionService,
    private outingService: OutingService,
    public dialog: MatDialog,
    private globalDataService: GlobalDataService,
    stringHelpers: StringHelpers) {
    super(sessionService, stringHelpers);
    this.filter.pageSize = 10;
    this.displayedColumns = ['firstName', 'lastName', 'addPermission', 'existingPermissions'];

   }

  ngOnInit(): void {
    if(this.isGlobalOutingSet()){
      this.selectedOuting = this.getGlobalOuting();
      this.getPermissionTypes();
      this.getOutingPermissionUsers();
    }
  }

  ngAfterViewInit(): void {
    this.globalDataService.outingSelectionEvent.subscribe(result => {
      this.selectedOuting = result;
      this.getOutingPermissionUsers();
    })
  }

  getOutingPermissionUsers(){
    this.isLoading = true;
    this.filter.outingId = this.selectedOuting.id;
    this.outingService.getUsersForPermissions(this.filter).subscribe(results =>{
      this.outingPermissionUsers = results.results;
      this.filter.totalCount = results.totalCount;
      this.updateFilterEvent.emit(results.results);
      this.isLoading = false;
    }, err => {
      this.isLoading = false;
    })
  }


  getPermissionTypes(){
    this.outingService.getPermissionTypes().subscribe(results => {
      this.outingPermissionTypes = results;
    });
  }

  addOutingPermissionToUser(permisstionType: OutingPermissionTypes, user: OutingPermissionUsersList){
    let doesPermissionExist = this.outingPermissionUsers.some(x => x.userPermissions.some(x => x.outingPermissionTypeId === permisstionType.id));

    if(!doesPermissionExist){
      let outingPermission: OutingPermssionDto = new OutingPermssionDto();
      outingPermission.userId = user.userId;
      outingPermission.outingId = this.selectedOuting.id;
      outingPermission.outingPermissionTypeId = permisstionType.id;
      outingPermission.createdBy = this.getUserIdFromSession();
      const dialogRef = this.dialog.open(AlertModalComponent);
      dialogRef.componentInstance.title = 'Permission Create';
      dialogRef.componentInstance.body = `Are you sure you want to add permission "${permisstionType.name}" for User "${user.firstName} ${user.lastName}"?`;
      dialogRef.componentInstance.submitText = 'Yes';
      dialogRef.afterClosed().subscribe((response) => {
        if(response === 'Yes')
        this.outingService.createOutingPermission(outingPermission).subscribe(() => {
          this.getOutingPermissionUsers();
        });
        this.isLoading = false;
      });
    } else{
      const dialogRef = this.dialog.open(AlertModalComponent);
      dialogRef.componentInstance.title = 'Permission Create Error';
      dialogRef.componentInstance.body = `"${permisstionType.name}" for user "${user.firstName} ${user.lastName}"
        already exists, please select another permission`;
      dialogRef.componentInstance.submitText = 'Okay';
      dialogRef.afterClosed().subscribe((response) => {
        this.isLoading = false;
      });
    }
    this.isLoading = false;
  }

  removePermission(permission: OutingPermissionTypes){
    this.isLoading = true;
    this.outingService.deleteOutingPermission({id: permission.id, lastEditedBy: this.getUserIdFromSession()}).subscribe(() => {
      this.getOutingPermissionUsers();
      this.isLoading = false;
    });
  }

  sortData(sort: Sort) {
    this.filter.sortDirection = sort.direction;
    this.filter.sortColumn = sort.active;
  }

  resetFilter() {
    this.filter.page = 1;
    this.filter.text = '';
    this.filter.pageSize = 10;
  }
}
